import type { Plan } from '../components/CardStack3D';

export const subscriptionPlans: Plan[] = [
  {
    id: 'marketing',
    name: 'Marketing',
    animationKey: 'marketing',
    price: 1495,
    cadence: '/month',
    description: 'Ideal for managed services such as SEO, Ads and social media',
    blurb: 'Pause or cancel anytime',
    features: [],
    offerings: [
      { key: 'bestfor', label: 'Best for', value: 'SEO, Ads & Social' },
      { key: 'requests', label: 'Active requests', value: '1 at a time' },
      { key: 'delivery', label: 'Average delivery', value: '~48 hours' },
      { key: 'seats', label: 'Users included', value: 'Up to 2' },
      { key: 'brands', label: 'Brands', value: 'Unlimited' },
      { key: 'stock', label: 'Stock photos', value: 'Unlimited' },
      { key: 'pause', label: 'Pause or cancel', value: 'Anytime' },
    ],
  },
  {
    id: 'digital-services',
    name: 'Digital Services',
    animationKey: 'digital',
    price: 3995,
    cadence: '/month',
    description:
      'Ideal for content creation, UI/UX, landing pages, brand creation and website builds',
    blurb: 'Priority support',
    popular: true,
    features: [],
    offerings: [
      { key: 'bestfor', label: 'Best for', value: 'Content, UI/UX, LPs, Brand & Sites' },
      { key: 'requests', label: 'Active requests', value: '1 at a time' },
      { key: 'delivery', label: 'Average delivery', value: '~36-48 hours' },
      { key: 'seats', label: 'Users included', value: 'Up to 3' },
      { key: 'web', label: 'Website development', value: 'Included' },
      { key: 'brands', label: 'Brands', value: 'Unlimited' },
      { key: 'qa', label: 'QA & testing', value: 'Included' },
    ],
  },
  {
    id: 'ecommerce-digital-services',
    name: 'Ecommerce Digital Services',
    animationKey: 'ecommerce',
    price: 5995,
    cadence: '/month',
    description: 'Ideal for product listings, complex integrations, platform builds',
    blurb: 'Best for scale',
    features: [],
    offerings: [
      { key: 'bestfor', label: 'Best for', value: 'Listings, Integrations, Platform builds' },
      { key: 'requests', label: 'Active requests', value: '2 in parallel' },
      { key: 'delivery', label: 'Average delivery', value: '~24-36 hours' },
      { key: 'seats', label: 'Users included', value: 'Up to 3' },
      { key: 'integrations', label: 'Integrations', value: 'Advanced' },
      { key: 'analytics', label: 'Analytics & tagging', value: 'Included' },
      { key: 'platforms', label: 'Platforms', value: 'Shopify, Woo, Headless' },
    ],
  },
];
